import Map from "ol/Map";
import DragPan from "ol/interaction/DragPan";
import Kinetic from "ol/Kinetic";
import MouseWheelZoom from "ol/interaction/MouseWheelZoom";

/**
 * 地図操作共通クラス
 */
export class mapOperation {
  private _map: Map;

  /**
   * マウスホイールでのズーム
   */
  private _mouseWheel: MouseWheelZoom = new MouseWheelZoom({
    constrainResolution: true,
    useAnchor: true,
    duration: 0,
  });

  /**
   * ドラッグ移動
   */
  private _dragPan: DragPan = new DragPan({
    kinetic: new Kinetic(-0.01, 0.1, 200),
  });

  /**
   * 拡大
   * @param map  地図クラス
   */
  public zoomIn(): void {
    this._map.getView().setZoom(this._map.getView().getZoom() + 1);
  }

  /**
   * 縮小
   * @param map  地図クラス
   */
  public zoomOut(): void {
    this._map.getView().setZoom(this._map.getView().getZoom() - 1);
  }

  /**
   * ドラッグ操作モード開始
   */
  public startDragMode(): void {
    this._map.addInteraction(this._dragPan);
    this._map.addInteraction(this._mouseWheel);
  }

  /**
   * コンストラクタ
   * @param map
   */
  constructor(map: Map) {
    this._map = map;
  }
}
